module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "ats-tree-node",
    class: {
      'is-expanded': _vm.node.expanded
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleClick(_vm.node, $event)
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.node.visible),
      expression: "node.visible"
    }],
    staticClass: "ats-tree-node__content",
    class: {
      'is-current': _vm.currentNodeId === _vm.node[_vm.treeProps.id], 'is-checked': _vm.node.checked
    },
    style: ({
      'padding-left': (_vm.node[_vm.treeProps.level] - 1) * 16 + 'px'
    })
  }, [_c('div', {
    staticClass: "ats-tree-node__icon icon"
  }, [(_vm.node[_vm.treeProps.children] && _vm.node[_vm.treeProps.children].length) ? _c('span', {
    staticClass: "ats-tree-node__expand-icon icon",
    class: {
      expanded: _vm.node.expanded
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "ats-tree-node__label",
    attrs: {
      "title": _vm.handleTitleVisible(_vm.node[_vm.treeProps.label])
    }
  }, [_vm._v(_vm._s(_vm.node[_vm.treeProps.label]))])]), _vm._v(" "), (_vm.node.expanded) ? _c('ul', {
    staticClass: "ats-tree-node__children"
  }, _vm._l((_vm.node[_vm.treeProps.children]), function(child) {
    return _c('tree-node', {
      key: child[_vm.treeProps.id],
      attrs: {
        "node": child,
        "treeProps": _vm.treeProps,
        "currentNodeId": _vm.currentNodeId,
        "eventHub": _vm.eventHub,
        "query": _vm.query,
        "isQuering": _vm.isQuering
      }
    })
  }), 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-676e315b","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/libcomponents/tree-select/tree-node.vue
// module id = 777
// module chunks = 1